var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeposit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.917 16L16.2503 21.3333M16.2503 21.3333L21.5837 16M16.2503 21.3333V9.06667C16.2503 7.21239 16.2503 6.28525 15.5163 5.2472C15.0286 4.55749 13.6244 3.70624 12.7874 3.59283C11.5275 3.42214 11.0491 3.67171 10.0922 4.17085C5.8281 6.39524 2.91699 10.8577 2.91699 16C2.91699 23.3638 8.88653 29.3333 16.2503 29.3333C23.6141 29.3333 29.5837 23.3638 29.5837 16C29.5837 11.0648 26.9023 6.75583 22.917 4.45043",
    stroke: "url(#paint0_linear_147_6750)",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_147_6750",
    x1: 29.5837,
    y1: 29.3333,
    x2: -1.92801,
    y2: 12.7405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB900"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/deposit.a42bc4d605205b50a158b81bd8e00b9e.svg";
export { ForwardRef as ReactComponent };